import { Link } from 'react-router-dom';
import { useApi } from '../hooks/useApi.js';
import { fetchCareers } from '../lib/api.js';
import { Seo } from '../components/Seo.jsx';
import { PageHeader } from '../components/PageHeader.jsx';
import { usePage } from '../hooks/usePage.js';

export function CareerPage() {
  const head = usePage('career');
  const { data: careers, loading } = useApi(fetchCareers, []);
  const list = careers || [];

  return (
    <>
      <Seo title="Career With Us" description={head.metaDescription} />

      <PageHeader
        crumbs={[{ label: 'Home', to: '/' }, { label: 'Career' }]}
        headline={head.headline}
        lede={head.lede}
        image={head.banner}
      />

      <section>
        <div className="container">
          {loading && <p style={{ color: 'var(--ink-3)' }}>Loading openings…</p>}

          {!loading && list.length === 0 && (
            <div style={{ padding: '48px 0', textAlign: 'center' }}>
              <p style={{ color: 'var(--ink-3)', maxWidth: '50ch', margin: '0 auto 28px' }}>
                We're not actively hiring at the moment. You're still welcome to send us your CV — we'll keep it on file.
              </p>
              <Link to="/contact" className="btn btn-primary">Send your CV</Link>
            </div>
          )}

          {!loading && list.length > 0 && (
            <div style={{ display: 'grid', gap: 16 }}>
              {list.map((job) => (
                <div className="career-row" key={job.id}>
                  <div>
                    <h3 style={{ fontSize: '1.3rem', marginBottom: 6 }}>{job.title}</h3>
                    <p style={{ margin: 0, color: 'var(--ink-3)', fontSize: 14 }}>
                      {[job.section, job.employmentType, job.location].filter(Boolean).join(' · ')}
                    </p>
                  </div>
                  <Link to="/contact" className="btn btn-ghost">Apply</Link>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
